import {Component, Input, OnInit} from '@angular/core';

export interface Config {
  src?: string;
  alt?: string;
  title?: string;
}

@Component({
  selector: 'ui-card',
  template: `<div class="card" style="width: 18rem;" *ngIf="config">
  <img class="card-img-top" src="{{config.src}}" alt="{{config.alt || config.title}}" *ngIf="config.src">
  <div class="card-body">
    <h5 class="card-title">{{config.title}}</h5>
    <ng-content></ng-content>
  </div>
</div>
`,
  styles: [``]
})
export class CardComponent implements OnInit {
  @Input() config: Config;

  constructor() {
  }

  ngOnInit() {
  }

}
